import { Container, Typography, Alert, Box, Stack, useTheme, alpha } from "@mui/material";
import DashboardLayout from "../../common/layouts/dashboard";
import { useSelector } from "react-redux";
import { user } from "../auth/auth/auth.slice";
import { Navigate } from "react-router-dom";
import UsersTab from "./components/UsersTab";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

function Admin() {
  const currentUser = useSelector(user);

  // Check if user is admin
  if (!currentUser?.isAdmin) {
    return <Navigate to="/projects" replace />;
  }

  const theme = useTheme();

  return (
    <DashboardLayout active="admin" name="Admin Panel">
      <Container maxWidth="xl" sx={{ py: 3 }}>
        <Stack spacing={3}>
          {/* Header Section */}
          <Box>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mb: 0 }}>
              Admin Dashboard
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Manage users, subscriptions, and platform settings
            </Typography>
          </Box>

          {/* Users Section */}
          <UsersTab />
        </Stack>
      </Container>
    </DashboardLayout>
  );
}

export default Admin;